import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgmCoreModule, AgmMap, LazyMapsAPILoader, MapsAPILoader, LAZY_MAPS_API_CONFIG } from '@agm/core';
import {NgxMaskModule} from 'ngx-mask';

import { InputmaskDirective } from './inputmask/inputmask.directive';
import { JqueryDatePickerDirective } from './jquery-date-picker/jquery-date-picker.directive';
import { AddressAutocompleteDirective } from './address-autocomplete/address-autocomplete.directive';
import { DatenputDirective } from './date-input.directive';
import { AgmmapProviderService } from '../providers/agmmap-provider.service';

@NgModule({
  imports: [
    CommonModule,
    AgmCoreModule.forRoot(),
    NgxMaskModule.forChild()
  ],
  declarations: [
    InputmaskDirective,
    JqueryDatePickerDirective,
    AddressAutocompleteDirective,
    DatenputDirective,
  ],
  exports: [
    InputmaskDirective,
    JqueryDatePickerDirective,
    AddressAutocompleteDirective,
    DatenputDirective,
  ],
  providers: [{
      provide: LAZY_MAPS_API_CONFIG,
      useClass: AgmmapProviderService
  }]
})
export class DirectivesModule { }



// WEBPACK FOOTER //
// ./src/app/shared/directives/directives.module.ts